// import React, {useState} from 'react'
// import './style.css'
// import Selected from '../../Assets/Icons/Selected'

// export const ImageContainer = (props) => {
//     const [isSelected, setIsSelected] = useState(false);

//     function handleClick(){
//         setIsSelected(prev=>!prev);
//     }
//     return (
//         <>
//             <div className={`container-border ${isSelected?'selected':''}`} onClick={handleClick}>
//                 <div className="image-container">
//                     {isSelected && (
//                         <div className="svg-overlay">
//                             <Selected />
//                         </div>
//                     )}
//                     <img src={props.image} alt="Sample Image" />
//                     <div className="overlay"><p className="overlay-text">{props.name}</p></div>
//                 </div>
//             </div>
//         </>
//     )
// }

import React from "react";
import "./style.css";
import Selected from "../../Assets/Icons/Selected";

export const ImageContainer = ({
  id,
  name,
  image,
  selectedSportId,
  selectedSaleId,
  price,
  setSelectedSport,
  sportId,
  isSelfPayMode = false,
}) => {
  // ✅ Selection logic
  const isSelected = isSelfPayMode
    ? selectedSaleId == id && selectedSportId == sportId
    : selectedSportId == id;

  return (
    <div
      className={`container-border ${
        isSelected ? "selected" : ""
      } list-sport-img-card`}
      onClick={() => setSelectedSport(id, sportId)}
    >
      <div className="image-container">
        {isSelected && (
          <div className="svg-overlay">
            <Selected />
          </div>
        )}

        <img src={image} alt={name} />

        <div className="overlay">
          <p className="overlay-text">{name}</p>

          {price && (
            <p className="overlay-text price">
              Price: <span>${price}</span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
